import { render } from "./ResizablePage.vue?vue&type=template&id=7d97915f&scoped=true"
import script from "./ResizablePage.vue?vue&type=script&lang=js"
export * from "./ResizablePage.vue?vue&type=script&lang=js"

import "./ResizablePage.vue?vue&type=style&index=0&id=7d97915f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d97915f"]])

export default __exports__